import { render, staticRenderFns } from "./ChartStatistics.vue?vue&type=template&id=869fe3da&"
import script from "./ChartStatistics.vue?vue&type=script&lang=js&"
export * from "./ChartStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports